import { Text, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { darkMode, lightMode } from "../../../lib/models/color-mode-colors";
import { SelectItem } from "../../../lib/types/SelectItem";
import OptionListItem from "./OptionListItem";

export interface OptionListProps {
  items: SelectItem[];
  selectedItem: SelectItem | null;
  cursor: number;
  handleItemClick: (item: SelectItem | null) => void;
  isLoading: boolean;
}

function OptionList(props: OptionListProps) {
  const {
    items,
    selectedItem,
    handleItemClick,
    cursor,
    isLoading = false,
  } = props;

  const bgColor = useColorModeValue(lightMode[100], darkMode[200]);

  const handleClick = (e: any, index: number) => {
    if (index === -1) return;

    const item = items[index];

    if (item) handleItemClick(item);
  };

  useEffect(() => {
    const itemHeight = 40;
    const list = document.querySelector<HTMLElement>(".list");
    if (list) list.scrollTop = cursor * itemHeight;
  }, [cursor]);

  if (isLoading) {
    return (
      <Text color="gray.500" padding={1 / 2} textAlign="center">
        Loading...
      </Text>
    );
  }

  return items.length > 0 ? (
    <>
      <ul
        style={{
          listStyle: "none",
          background: `${bgColor}`,
        }}
        className="option-list"
        tabIndex={-1}
      >
        {items.map((item, i) => (
          <OptionListItem
            key={item.value}
            item={item}
            hasFocus={i === cursor}
            isSelected={
              selectedItem ? item.value === selectedItem.value : false
            }
            index={i}
            onClick={handleClick}
          />
        ))}
      </ul>
    </>
  ) : (
    <Text color="gray.500" padding={1 / 2} textAlign="center">
      No options
    </Text>
  );
}

export default OptionList;
